import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { ClusterRequest } from '../../types/cluster'

const { CLUSTERS_API_URL } = CONSTANT

const createNewCluster = async (
	newCluster: ClusterRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${CLUSTERS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'CREATE'
		},
		body: JSON.stringify(newCluster)
	})
	return response.json()
}

export default createNewCluster
